module.exports = __webpack_public_path__ + "static/media/uprightSoft.05adaef2.svg";